
export const SPANISH_LANGUAGE_TEXTS = {
  // Search results
  TIPO_MATERIAL_DELTALLE_TITLE : 'Tipología',
  ACBABADO_DELTALLE_TITLE: 'Acabado',
  ESPESOR_MATERIAL_DELTALLE_TITLE: 'Espesor',
  COLOR_MATERIAL_DELTALLE_TITLE: 'Color',
  RANGO_ANCHO_DELTALLE_TITLE: 'Rango de ancho',
  RANGO_ALTO_DELTALLE_TITLE: 'Rango de alto',
  PIEZAS_DELTALLE_TITLE: 'Piezas',
  NUMERO_LOTE: 'Núm. Lote',
  BLOQUE_TEXT: 'Bloque',
  PAQUETE_TITLE: 'Paquete',
  PAQUETES_TITLE: 'Paquetes',
  NO_RESULTS_TITLE: 'Sin resultados',
  ANCHO_MATERIAL_TITLE: 'Ancho', //
  LARGO_MATERIAL_TITLE: 'Largo', //
  ALTO_MATERIAL_TITLE: 'Alto', //
  MEDIDAS_TITLE: 'Medidas', //
  MEDIDAS_ANCHO_TITLE: 'Ancho', //
  MEDIDAS_ALTO_TITLE: 'Alto', //
  SLAB_NUMBER_TITLE: 'Tabla Nº',
  CARGANDO: 'Cargando...',
  // filters
  TIPO_MATERIAL_FILTER_TITLE: 'Tipología',
  ACABADO_MATERIAL_FILTER_TITLE: 'Acabado',
  ESPESOR_FILTER_TTILE: 'Espesor',
  DISPONIBILIDAD_FILTER_TITLE: 'Disponibilidad',
  COLOR_MATERIAL_TITLE: 'Color',
  USO_MATERIAL_FILTER_TITLE: 'Usos',
  ORIGEN_MATERIAL_TITLE: 'Origen',
  RANGO_MEDIDA_FILTER_TITLE: 'Rango de medida',
  RANGO_PRECIO_FILTER_TITLE: 'Rango precios',
  RANGO_SUPERFICIE_FILTER_TITLE: 'Rango superficie',
  // barra filtros
  RESULTS_CONTER_TITLE: 'Resultados',
  BORRAR_FILTROS_TITLE: 'Borrar filtros',
  FILTERS_BAR_PLACEHOLDER: 'Buscar filtro',
  FILTERS_BAR_KEYWORD_PLACEHOLDER: 'Buscador',
  // detalles
  BOOKMATCH_BUTTON_TEXT: 'Ver Bookmatch',
  // materiales similares
  MATERIALES_SIMILARES_TITLE: 'Productos de tono similar',
  // medidas
  CM: 'cm', //
  PULGADAS: 'Inch', //
  METROS: 'Metros',
  SUPERFICIE: 'Superficie',
  // detalle
  SIMILARES_TITLE: 'Productos similares',
  VER_BOOKMATCH: 'Ver Bookmatch',
  FICHA_DATOS: 'FICHA TÉCNICA',
  SI: 'Sí',
  NO: 'No',
  ATRAS: 'ATRÁS',
  //rango
  A: 'a',
  // menu  
  PRODUCTOS_MENU : 'Productos',
  LIBRARY_MENU : 'Library',
  CATALOGOS_MENU : 'Catálogos',
  SERVICIOS_MENU : 'Servicios',
  SHOWROOM_MENU : 'Showroom',
  NOSOTROS_MENU : 'Sobre nosotros',
  CONTACTO_MENU : 'Contáctenos',
  PRODUCTOS_MENU_LINK : '/es/productos/',
  CATALOGOS_MENU_LINK : '/es/catalogos/',
  SERVICIOS_MENU_LINK : '/es/servicios/',
  SHOWROOM_MENU_LINK : '/es/showroom/',
  NOSOTROS_MENU_LINK : '/es/sobre-nosotros/',
  CONTACTO_MENU_LINK : '/es/contactenos/'
}
